import { render, staticRenderFns } from "./BaseCheckboxInput.vue?vue&type=template&id=1cb0f1aa"
import script from "./BaseCheckboxInput.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxInput.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckboxInput.vue?vue&type=style&index=0&id=1cb0f1aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports